export const Roles = {
    ADMIN: "ADMIN",
    USER: "USER",
    PARTNER: "PARTNER"
}